import { List, Stack, CircularProgress } from '@mui/material';
import { isNotEmpty } from 'ramda';

import { useCockpitContext } from '../../../CockpitContextProvider/CockpitContextProvider.hook';
import { SvbrgCategoryType } from '@/generated/gql/graphql';

import { ThreadSummaryListItem } from './components/ThreadSummaryListItem/ThreadSummaryListItem';
import { ThreadSummaryListItemEmpty } from './components/ThreadSummaryListItemEmpty/ThreadSummaryListItemEmpty';
import { useThreadCategory } from './ThreadList.hook';

export interface AgentCategoryProps {
  categories: SvbrgCategoryType[];
  textFilter?: string;
}

export const ThreadList = ({ categories, textFilter }: AgentCategoryProps) => {
  const { categoryData, loading } = useThreadCategory({ categories, textFilter });
  const { threadId } = useCockpitContext();

  return (
    <>
      {loading ? (
        <Stack height={48} justifyContent="center" alignItems="center">
          <CircularProgress size={24} />
        </Stack>
      ) : (
        <List>
          {isNotEmpty(categoryData) ? (
            categoryData.map((thread) => (
              <ThreadSummaryListItem
                key={thread.id}
                status={thread.status}
                processingStatus={thread.processingStatus}
                variant={thread.variant}
                summary={thread.summary}
                timestamp={thread.timestamp}
                isSelected={threadId === thread.id}
                targetId={thread.conversationSettingsEntityId ?? thread.id}
              />
            ))
          ) : (
            <ThreadSummaryListItemEmpty />
          )}
        </List>
      )}
    </>
  );
};
